import { render, staticRenderFns } from "./LimitsTable.vue?vue&type=template&id=314d8b2f&"
import script from "./LimitsTable.vue?vue&type=script&lang=ts&"
export * from "./LimitsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports